import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useRef, createRef } from 'react';
import { createPortal } from 'react-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import styled from '../../styles/styled';
import { Button, IconButton } from '../buttons';
import { AppIcon } from '../icons';
import { Box } from '../layout';
import { AppText } from '../typography';
export const Snackbar = ({ content, position, onPauseSnackTimeout, onResumeSnackTimeout, isTrayOpen, }) => {
    const snackRef = useRef();
    const classes = {
        enter: 'fade-enter',
        enterActive: 'fade-enter-active',
        exit: 'fade-exit',
        exitActive: 'fade-exit-active',
    };
    return (_jsx(Box, { className: "snackbar", ref: snackRef, children: createPortal(_jsx(TransitionComponent, { vertical: position.vertical, horizontal: position.horizontal, istrayopen: isTrayOpen ? 'true' : null, children: content.map(({ id, message, actionMessage, icon, level, timeout, backgroundColor, onActionClick, useCloseButton, }) => {
                const ref = createRef();
                return (_jsx(TransitionWrapper, { classes: classes, classNames: "fade", timeout: 300, nodeRef: ref, unmountOnExit: true, children: _jsx(SnackBarWrapper, { ref: ref, role: "status", children: _jsx(SnackBarContent, { backgroundColor: backgroundColor, message: message, actionMessage: actionMessage, icon: icon, id: id, level: level, onPauseSnackTimeout: onPauseSnackTimeout
                                ? () => onPauseSnackTimeout(id)
                                : null, onResumeSnackTimeout: onResumeSnackTimeout
                                ? () => onResumeSnackTimeout(id, timeout)
                                : null, onActionClick: () => onActionClick ? onActionClick(id) : null, useCloseButton: useCloseButton }) }) }, id));
            }) }), document.body) }));
};
const SnackBarContent = ({ message, actionMessage, icon, level = 'info', onPauseSnackTimeout, onResumeSnackTimeout, backgroundColor, onActionClick, useCloseButton = false, }) => {
    const defaultIconMapping = {
        info: _jsx(AppIcon, { name: "InformationIcon" }),
    };
    return (_jsxs(SnackBarContentWrapper, { backgroundColor: backgroundColor, onMouseEnter: onPauseSnackTimeout, onFocus: onPauseSnackTimeout, onMouseLeave: onResumeSnackTimeout, onBlur: onResumeSnackTimeout, children: [icon !== false ? _jsx(IconWrapper, { children: icon || defaultIconMapping[level] }) : null, _jsx(Box, { padding: "8px 0", children: _jsx(AppText, { fontFamily: "ASAP, sans-serif", fontSize: 12, children: message }) }), (actionMessage || useCloseButton) && (_jsx(SnackBarContentAction, { children: useCloseButton ? (_jsx(IconButton, { iconName: "CloseIcon", size: "medium", label: "close", onClick: () => onActionClick(), background: 'transparent' })) : (_jsx(Button, { onClick: () => onActionClick(), variant: "tertiary", "aria-label": actionMessage, role: "button", children: actionMessage })) }))] }));
};
const SnackBarContentAction = styled.div(() => ({
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    paddingLeft: 16,
    marginRight: -8,
}));
const SnackBarContentWrapper = styled.div(({ theme, backgroundColor }) => ({
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    flexGrow: 1,
    padding: '10px 16px',
    borderRadius: '8px',
    backgroundColor: backgroundColor || theme.colors.white,
    minWidth: '178px',
}));
const IconWrapper = styled.div(() => ({
    display: 'flex',
    marginRight: '8px',
}));
const SnackBarWrapper = styled.div(({ theme }) => ({
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    borderRadius: '8px',
    boxShadow: theme.shadow.bottomLarge,
    marginBottom: '16px',
}));
const TransitionWrapper = styled(CSSTransition)(({ classes }) => ({
    position: 'relative',
    [`&.${classes.enter}`]: {
        opacity: 0,
    },
    [`&.${classes.enterActive}`]: {
        opacity: 1,
        transition: 'opacity 300ms, transform 300ms',
    },
    [`&.${classes.exit}`]: {
        opacity: 1,
    },
    [`&.${classes.exitActive}`]: {
        opacity: 0,
        transition: 'opacity 300ms, transform 300ms',
    },
}));
const TransitionComponent = styled(TransitionGroup)(({ horizontal, vertical, istrayopen }) => {
    return {
        position: 'fixed',
        zIndex: 1400,
        ...(vertical === 'top' ? { top: '24px' } : { bottom: '24px' }),
        ...(horizontal === 'center' &&
            (istrayopen
                ? { left: 'calc(50vw + 256px)', transform: 'translateX(-64%)' }
                : { left: '50%', transform: 'translateX(-50%)' })),
        ...(horizontal === 'left' && { left: '24px', right: 'auto' }),
        ...(horizontal === 'right' && { right: '24px', left: 'auto' }),
    };
});
//# sourceMappingURL=snackbar.js.map